/**
 * Detecção de dispositivo para decidir o convite de app pós-login.
 *
 * A regra do produto: o modal do app só faz sentido no celular. Em notebook o
 * app Android/PWA não ajuda, e em tablet a experiência de "app no bolso" não é
 * o alvo — então ambos ficam de fora.
 *
 * Não existe API 100% confiável para isso no navegador; combinamos pistas do
 * user agent com o tamanho da tela, que na prática separa bem os três casos.
 */

const ua = () =>
  (navigator.userAgent || navigator.vendor || window.opera || '').toLowerCase();

/** iPhone/iPod. iPad é tratado à parte porque se identifica como desktop. */
export function isIOS() {
  const s = ua();
  const iPhone = /iphone|ipod/.test(s);
  // iPad moderno (iPadOS 13+) se apresenta como "Macintosh"; o toque o denuncia.
  // Mas iPad é tablet, então NÃO entra aqui — fica fora do modal de propósito.
  return iPhone;
}

/** Android em geral (celular ou tablet). */
export function isAndroid() {
  return /android/.test(ua());
}

/**
 * Tablet: iPad (inclusive o disfarçado de Mac) ou Android sem "mobile" no UA
 * (o Chrome do Android põe "Mobile" só em celular, não em tablet).
 */
export function isTablet() {
  const s = ua();
  const iPadClassico = /ipad/.test(s);
  const iPadComoMac = /macintosh/.test(s) && navigator.maxTouchPoints > 1;
  const androidTablet = /android/.test(s) && !/mobile/.test(s);
  return iPadClassico || iPadComoMac || androidTablet;
}

/**
 * Smartphone: iPhone, ou Android com "mobile" no UA. Tablets são explicitamente
 * excluídos. Como rede de segurança, exige também uma largura de tela pequena —
 * um desktop com UA adulterado não dispara o modal.
 */
export function isSmartphone() {
  if (isTablet()) return false;
  const telaPequena = Math.min(window.innerWidth, window.innerHeight) <= 820;
  const celular = isIOS() || (isAndroid() && /mobile/.test(ua()));
  return celular && telaPequena;
}

/** Plataforma do smartphone, para o modal escolher a mensagem. */
export function plataformaSmartphone() {
  if (!isSmartphone()) return null;
  if (isIOS()) return 'ios';
  if (isAndroid()) return 'android';
  return null;
}
